import type { TourStep } from '../components/ui/tour';

/**
 * قدم‌های تورِ «داشبورد جامع باشگاه مشتریان».
 * انتخاب‌گرها به wrapperهای data-tour در ClubDashboard متصل‌اند.
 * در سطحِ ماژول ثابت تعریف شده تا identity پایدار بماند (لازمِ useDashboardTour).
 */
export const CLUB_TOUR: TourStep[] = [
  {
    title: '👋 به راهنمای باشگاه مشتریان خوش آمدید',
    description:
      'در چند قدم کوتاه، بخش‌های اصلی این داشبورد را روی خودِ صفحه معرفی می‌کنیم. با دکمه‌ی «بعدی» جلو بروید.',
  },
  {
    element: '[data-tour="club-params"]',
    title: 'پارامترهای باشگاه',
    description:
      'این جدول شاخص‌های کلیدیِ باشگاه مشتریان را در بازه‌ی زمانیِ انتخاب‌شده نشان می‌دهد. برای دیدنِ جزئیات و نمودارِ هر شاخص می‌توانید با ستون‌های جدول کار کنید.',
    side: 'top',
    align: 'center',
  },
  {
    element: '[data-tour="club-sales"]',
    title: 'پارامترهای فروش',
    description:
      'این جدول شاخص‌های فروشِ مرتبط با باشگاه را نمایش می‌دهد تا تأثیر فعالیت‌های باشگاه بر فروش را در یک نگاه ببینید.',
    side: 'top',
    align: 'center',
  },
  {
    element: '[data-tour="club-guide-btn"]',
    title: 'راهنمای کامل',
    description:
      'برای توضیحِ جزئیاتِ هر بخش و هر شاخص، هر زمان روی این دکمه بزنید. تور تمام شد ✅',
    side: 'bottom',
    align: 'center',
    centerOnScroll: true,
  },
];
